import React, { useEffect, useState } from 'react';
import { tenantsApi } from '../../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    totalTenants: 0,
    activeTenants: 0,
    totalProjects: 0,
    totalUsers: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const tenants = await tenantsApi.getAll();
      
      const activeTenants = tenants.filter(t => t.status === 'active').length;
      const totalProjects = tenants.reduce((sum, t) => sum + (t.usage?.projects || 0), 0);
      const totalUsers = tenants.reduce((sum, t) => sum + (t.usage?.users || 0), 0);

      setStats({
        totalTenants: tenants.length,
        activeTenants,
        totalProjects,
        totalUsers
      });
      setLoading(false);
    } catch (error) {
      console.error('Failed to load stats:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard</h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard
          title="Tenants Totali"
          value={stats.totalTenants}
          icon="🏢"
          color="bg-blue-500"
        />
        <StatCard
          title="Tenants Attivi"
          value={stats.activeTenants}
          icon="✅"
          color="bg-green-500"
        />
        <StatCard
          title="Progetti Totali"
          value={stats.totalProjects}
          icon="📁"
          color="bg-purple-500"
        />
        <StatCard
          title="Utenti Totali"
          value={stats.totalUsers}
          icon="👥"
          color="bg-orange-500"
        />
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <QuickAction
            title="Nuovo Tenant"
            description="Crea un nuovo tenant"
            icon="➕"
            href="/admin/tenants"
          />
          <QuickAction
            title="Gestisci Plans"
            description="Modifica piani disponibili"
            icon="💳"
            href="/admin/plans"
          />
          <QuickAction
            title="AI Prompts"
            description="Configura prompts AI"
            icon="💬"
            href="/admin/prompts"
          />
          <QuickAction
            title="AI Models"
            description="Gestisci modelli AI"
            icon="🤖"
            href="/admin/models"
          />
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, value, icon, color }) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-gray-900">{value}</p>
        </div>
        <div className={`${color} w-12 h-12 rounded-lg flex items-center justify-center text-2xl`}>
          {icon}
        </div>
      </div>
    </div>
  );
}

function QuickAction({ title, description, icon, href }) {
  return (
    <a
      href={href}
      className="block p-4 border-2 border-gray-200 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition-all group"
    >
      <div className="text-3xl mb-2">{icon}</div>
      <h3 className="font-semibold text-gray-900 group-hover:text-indigo-600 mb-1">
        {title}
      </h3>
      <p className="text-sm text-gray-600">{description}</p>
    </a>
  );
}
